export function getDrawControl(map) {
	return map._controls.find((control) => control.modes);
}
